import { backend } from 'modules/data';

export const getDefaultDueDate = (
    documentDate: string,
    day: number,
    termType: `${backend.IntegrationsXeroPaymentTermType}`
) => {
    const dueDate = new Date(documentDate);

    switch (termType) {
        case backend.IntegrationsXeroPaymentTermType.AfterBillDate:
            dueDate.setDate(dueDate.getDate() + day);
            break;

        case backend.IntegrationsXeroPaymentTermType.AfterBillMonth:
            dueDate.setDate(1);
            dueDate.setMonth(dueDate.getMonth() + 1);
            dueDate.setDate(dueDate.getDate() + day - 1);
            break;

        case backend.IntegrationsXeroPaymentTermType.CurrentMonth: {
            const daysInMonth = new Date(dueDate.getFullYear(), dueDate.getMonth() + 1, 0).getDate();

            dueDate.setDate(Math.min(day, daysInMonth));
            break;
        }

        case backend.IntegrationsXeroPaymentTermType.FollowingMonth: {
            const daysInMonth = new Date(dueDate.getFullYear(), dueDate.getMonth() + 2, 0).getDate();

            dueDate.setDate(Math.min(day, daysInMonth));
            dueDate.setMonth(dueDate.getMonth() + 1);
            break;
        }

        default:
            break;
    }

    return dueDate.toISOString();
};
